<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Txt } from '$global/components/Txt';

	interface Props {
		dataCy: string;
		children?: import('svelte').Snippet;
		class?: string;
	}

	let { ...props }: Props = $props();
</script>

<span
	data-cy={`${props.dataCy}-label`}
	class={twMerge(
		'absolute top-2 left-2 z-10 rounded-lg bg-gray-900 p-1',
		props.class
	)}
>
	<Txt variant="label4" class="text-white">{@render props.children?.()}</Txt
	></span
>
